// extracted by mini-css-extract-plugin
module.exports = {"paper":"map_paper__hNHrW","iframe":"map_iframe__DYng_","loader":"map_loader__1G7bn"};